import Layout from '@/layout';
import routerView from "@/components/otherTpl/routerView";

export default {
    path: '/resources',
    redirect: '/resources/supplierManage/supplierManageList',
    component: Layout,
    alwaysShow: true,
    meta: {
        title: '资源',
        icon: 'menu_zy',
        modules: [16000]
    },
    children: [
        // 供应方管理
        {
            path: 'supplierManage',
            redirect: '/resources/supplierManage/supplierManageList',
            component: routerView,
            meta: {
                title: '供应方管理',
                icon: 'spot',
                modules: [16003]
            },
            children: [
                // 供应方列表
                {
                    path: 'supplierManageList',
                    name: 'SupplierManageList',
                    hidden: true,
                    component: () => import('@/views/resources/supplierManage/index'),
                    meta: {
                        title: '供应方列表',
                        activeMenu: '/resources/supplierManage',
                        modules: [16003]
                    }
                },
                // 供应方详情
                {
                    path: 'supplierDetail/:id',
                    name: 'SupplierDetail',
                    hidden: true,
                    component: () => import('@/views/resources/supplierManage/supplierDetail'),
                    meta: {
                        title: '供应方详情',
                        activeMenu: '/resources/supplierManage',
                        modules: [16003]
                    }
                }
            ]
        },
        // 资源管理
        {
            path: 'resourceManage',
            component: routerView,
            redirect: '/resources/resourceManage/communityMedia',
            meta: {
                title: '资源管理',
                icon: 'spot',
                modules: [16008]
            },
            children: [
                // 社区媒体
                {
                    path: 'communityMedia',
                    name: 'CommunityMedia',
                    component: routerView,
                    redirect: '/resources/resourceManage/communityMedia/index',
                    meta: {
                        title: '社区媒体',
                        modules: [16004]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'ResourceManageList',
                            component: () => import('@/views/resources/resourceManage/index'),
                            meta: {
                                title: '社区媒体',
                                breadcrumb: false,
                                keepAlive: true,
                                activeMenu: '/resources/resourceManage/communityMedia/index',
                                modules: [16004]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'ResourceManageDetail',
                            hidden: true,
                            component: () => import('@/views/resources/resourceManage/detail'),
                            meta: {
                                title: '社区媒体详情',
                                keepAlive: false,
                                activeMenu: '/resources/resourceManage/communityMedia/index',
                                modules: [16004]
                            }
                        },
                        {
                            path: 'communityLevel/:id',
                            name: 'ResourceManageCommunityLevel',
                            hidden: true,
                            component: () => import('@/views/resources/resourceManage/communityLevel'),
                            meta: {
                                title: '社区层级',
                                activeMenu: '/resources/resourceManage',
                                modules: [16004]
                            }
                        }
                        // {
                        //     path: 'addResource',
                        //     name: 'AddResource',
                        //     hidden: true,
                        //     component: () => import('@/views/resources/resourceManage/components/resourceAdd'),
                        //     meta: {
                        //         title: '新增社区媒体',
                        //         activeMenu: '/resources/resourceManage/communityMedia/index',
                        //         modules: [16004]
                        //     }
                        // }
                    ]
                },
                // 地铁资源管理
                {
                    path: 'subwayMedia',
                    component: routerView,
                    redirect: '/resources/resourceManage/subwayMedia/subwayMediaList',
                    meta: {
                        title: '地铁资源管理',
                        modules: [16005]
                    },
                    children: [
                        {
                            path: 'subwayMediaList',
                            name: 'SubwayMediaList',
                            hidden: true,
                            component: () => import('@/views/resources/subwayMedia/index'),
                            meta: {
                                title: '媒体列表',
                                keepAlive: true,
                                activeMenu: '/resources/resourceManage/subwayMedia',
                                modules: [16005]
                            }
                        },
                        {
                            path: 'addRouteForm',
                            name: 'AddRouteForm',
                            hidden: true,
                            component: () => import('@/views/resources/subwayMedia/component/routeForm'),
                            meta: {
                                title: '新增车载媒体',
                                activeMenu: '/resources/resourceManage/subwayMedia',
                                modules: [16005]
                            }
                        },
                        {
                            path: 'editRouteForm/:id',
                            name: 'EditRouteForm',
                            hidden: true,
                            component: () => import('@/views/resources/subwayMedia/component/routeForm'),
                            meta: {
                                title: '编辑车载媒体',
                                activeMenu: '/resources/resourceManage/subwayMedia',
                                modules: [16005]
                            }
                        },
                        {
                            path: 'routeDetail/:id',
                            name: 'RouteDetail',
                            hidden: true,
                            component: () => import('@/views/resources/subwayMedia/routeDetail'),
                            meta: {
                                title: '线路媒体详情',
                                activeMenu: '/resources/resourceManage/subwayMedia',
                                modules: [16005]
                            }
                        },
                        {
                            path: 'addStationForm',
                            name: 'AddStationForm',
                            hidden: true,
                            component: () => import('@/views/resources/subwayMedia/component/stationForm'),
                            meta: {
                                title: '新增站点媒体',
                                activeMenu: '/resources/resourceManage/subwayMedia',
                                modules: [16005]
                            }
                        },
                        {
                            path: 'editStationForm/:id',
                            name: 'EditStationForm',
                            hidden: true,
                            component: () => import('@/views/resources/subwayMedia/component/stationForm'),
                            meta: {
                                title: '编辑站点媒体',
                                activeMenu: '/resources/resourceManage/subwayMedia',
                                modules: [16005]
                            }
                        },
                        {
                            path: 'stationDetail/:id',
                            name: 'StationDetail',
                            hidden: true,
                            component: () => import('@/views/resources/subwayMedia/stationDetail'),
                            meta: {
                                title: '站点媒体详情',
                                activeMenu: '/resources/resourceManage/subwayMedia',
                                modules: [16005]
                            }
                        }
                    ]
                }
            ]
        },
        // 外采资源
        {
            path: 'outResources',
            component: routerView,
            redirect: '/resources/outResources/index',
            meta: {
                title: '外采资源',
                icon: 'spot',
                modules: [16007]
            },
            children: [
                {
                    path: 'index',
                    name: 'OutResources',
                    hidden: true,
                    component: () => import('@/views/resources/outResources/index'),
                    meta: {
                        title: '外采资源列表',
                        activeMenu: '/resources/outResources',
                        keepAlive: true,
                        modules: [16007]
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'OutResourcesDetail',
                    hidden: true,
                    component: () => import('@/views/resources/outResources/outResourcesDetail'),
                    meta: {
                        title: '外采资源详情',
                        activeMenu: '/resources/outResources',
                        modules: [16007]
                    }
                },
                {
                    path: 'add',
                    name: 'OutResourcesForm',
                    hidden: true,
                    component: () => import('@/views/resources/outResources/outResourcesForm'),
                    meta: {
                        title: '新增外采资源',
                        activeMenu: '/resources/outResources',
                        modules: [16007]
                    }
                }
            ]
        },
        // 资源工具
        {
            path: 'toolBox',
            component: routerView,
            redirect: '/resources/toolBox/index',
            meta: {
                title: '资源工具箱',
                icon: 'spot',
                modules: [16006]
            },
            children: [
                {
                    path: 'index',
                    name: 'ResourcesToolBox',
                    component: () => import('@/views/resources/toolBox/index'),
                    meta: {
                        breadcrumb: false,
                        title: '资源工具箱',
                        modules: [16006]
                    }
                },
                {
                    path: 'circle',
                    name: 'CircleTool',
                    hidden: true,
                    component: routerView,
                    redirect: '/resources/toolBox/circle/index',
                    meta: {
                        activeMenu: '/resources/toolBox/index',
                        modules: [16111]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'CircleToolIndex',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/circle/index'),
                            meta: {
                                title: '商圈划分',
                                keepAlive: true,
                                activeMenu: '/resources/toolBox/index',
                                modules: [16111]
                            }
                        },
                        {
                            path: 'add',
                            name: 'CircleToolAdd',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/circle/map/index'),
                            meta: {
                                title: '商圈划分',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16111]
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'CircleToolEdit',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/circle/map/index'),
                            meta: {
                                title: '商圈划分',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16111]
                            }
                        }
                    ]
                },
                {
                    path: 'community',
                    name: 'CommunityTool',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/batchtools/community'),
                    meta: {
                        title: '批量工具',
                        keepAlive: true,
                        activeMenu: '/resources/toolBox/index',
                        modules: [16104]
                    }
                },
                {
                    path: 'framPosi',
                    name: 'FramPosiTool',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/batchtools/framPosi'),
                    meta: {
                        title: '广告位批量工具',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16104]
                    }
                },
                {
                    path: 'warningComm',
                    name: 'WarningComm',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/warning'),
                    meta: {
                        title: '到期预警',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16106],
                        keepAlive: true
                    }
                },
                {
                    path: 'warningFram',
                    name: 'WarningFram',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/warning/frameWaring'),
                    meta: {
                        title: '到期预警广告位',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16106]
                    }
                },
                {
                    path: 'taskupStatistics',
                    name: 'ResTaskupStatistics',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/taskupStatistics'),
                    meta: {
                        title: '上刊情况',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16109]
                    }
                },
                {
                    path: 'positionChange',
                    name: 'PositionChange',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/positionChange'),
                    meta: {
                        title: '版位变动',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16107]
                    }
                },
                {
                    path: 'positionHits',
                    name: 'PositionHits',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/positionHits'),
                    meta: {
                        title: '版位点击率',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16110]
                    }
                },
                {
                    path: 'incomeStatistics',
                    component: routerView,
                    redirect: '/resources/toolBox/incomeStatistics/index',
                    hidden: true,
                    meta: {
                        title: '收益情况',
                        modules: [16113]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'IncomeStatisticsIndex',
                            component: () => import('@/views/resources/toolBox/incomeStatistics'),
                            meta: {
                                breadcrumb: false,
                                title: '收益情况',
                                activeMenu: '/resources/toolBox/index',
                                keepAlive: true,
                                modules: [16113]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'IncomeStatisticsDetail',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/incomeStatistics/detail'),
                            meta: {
                                title: '收益详情',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16113]
                            }
                        }
                    ]
                },
                {
                    path: 'handoverComm',
                    name: 'HandoverComm',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/handoverComm'),
                    meta: {
                        title: '社区交接',
                        activeMenu: '/resources/toolBox/index',
                        keepAlive: true,
                        modules: [16105]
                    }
                },
                {
                    path: 'handoverDetail/:id',
                    name: 'HandoverCommDetail',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/handoverComm/detail'),
                    meta: {
                        title: '社区详情',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16105]
                    }
                },
                {
                    path: 'communityDetail',
                    name: 'CommunityDetail',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/communityDetail'),
                    meta: {
                        title: '社区信息',
                        activeMenu: '/resources/toolBox/index',
                        keepAlive: true,
                        modules: [16112]
                    }
                },
                {
                    path: 'communityDetail/edit/:id',
                    name: 'CommunityDetailEdit',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/communityDetail/form'),
                    meta: {
                        title: '编辑社区',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16112]
                    }
                },
                {
                    path: 'communityDetail/detail/:id',
                    name: 'CommunityDetailDetail',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/communityDetail/detail'),
                    meta: {
                        title: '社区详情',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16112]
                    }
                },
                {
                    path: 'taskupRepair',
                    name: 'RaskupRepair',
                    hidden: true,
                    component: () => import('@/views/resources/toolBox/taskupRepair'),
                    meta: {
                        title: '任务报修',
                        activeMenu: '/resources/toolBox/index',
                        modules: [16108]
                    }

                },
                {
                    path: 'installationSheet',
                    component: routerView,
                    redirect: '/resources/toolBox/installationSheet/index',
                    hidden: true,
                    meta: {
                        title: '安装单',
                        modules: [16011]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'InstallationSheet',
                            component: () => import('@/views/resources/toolBox/workingSheet/installationSheet/index'),
                            meta: {
                                breadcrumb: false,
                                title: '安装单',
                                activeMenu: '/resources/toolBox/index',
                                keepAlive: true,
                                modules: [16011]
                            }
                        },
                        {
                            path: 'add',
                            name: 'addInstallationSheet',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/workingSheet/installationSheet/resInstallAdd'),
                            meta: {
                                title: '新增安装单',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16011]
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'editInstallationSheet',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/workingSheet/installationSheet/resInstallAdd'),
                            meta: {
                                title: '编辑安装单',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16011]
                            }
                        },
                        {
                            path: 'details/:id',
                            name: 'installDetails',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/workingSheet/installationSheet/installDetail'),
                            meta: {
                                title: '安装单详情',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16011]
                            }
                        }
                    ]
                },
                {
                    path: 'demolitionSheet',
                    component: routerView,
                    redirect: '/resources/toolBox/demolitionSheet/index',
                    hidden: true,
                    meta: {
                        title: '拆除单',
                        modules: [16012]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'DemolitionSheet',
                            component: () => import('@/views/resources/toolBox/workingSheet/demolitionSheet/index'),
                            meta: {
                                breadcrumb: false,
                                title: '拆除单',
                                activeMenu: '/resources/toolBox/index',
                                keepAlive: true,
                                modules: [16012]
                            }
                        },
                        {
                            path: 'add',
                            name: 'addDemolition',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/workingSheet/demolitionSheet/resDemoAdd'),
                            meta: {
                                title: '新增拆除单',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16012]
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'demolitionEdit',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/workingSheet/demolitionSheet/resDemoAdd'),
                            meta: {
                                title: '编辑拆除单',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16012]
                            }
                        },
                        {
                            path: 'details/:id',
                            name: 'demolitionDetails',
                            hidden: true,
                            component: () => import('@/views/resources/toolBox/workingSheet/demolitionSheet/resDemoliDetail'),
                            meta: {
                                title: '拆除单详情',
                                activeMenu: '/resources/toolBox/index',
                                modules: [16012]
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

